import React from "react";

export default function ProductSlogan() {
  return (
    <div>
      <h3 className="h4-24-bold text-center md:h3-36-bold text-dark-major mb-1 md:mb-4">
        We build for collaborations
      </h3>
      <p className="p-16-normal md:p-18-normal text-dark-minor text-center">
        The collaboration upon users' credit
      </p>
    </div>
  );
}
